import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { GetInstallmentsByLoanId } from "adminApi/LoanReportApi/LoanReportApi";
import Spinner from "Common/Globle/Spinner";
import DataTable from "Common/DataTable/DataTable";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";

const ViewInstallment = () => {
    const { id } = useParams();
    const [installments, setInstallments] = useState([]);
    const [loading, setLoading] = useState(true);
    const hasFetched = useRef(false);

    const displayFields = [
        { name: "installment_no", label: "Installment No", type: "text" },
        { name: "installment_amount_display", label: "Installment Amount", type: "text" },
        { name: "payment_amount_display", label: "Payment Amount", type: "text" },
        { name: "payment_date_display", label: "Payment Date", type: "text" },
        { name: "receiver_name", label: "Receiver", type: "text" },
        { name: "notes", label: "Notes", type: "text" },
    ];

    const formattedInstallments = installments.map((installment) => ({
        ...installment,
        installment_amount_display: installment.installment_amount,
        payment_amount_display: installment.payment_amount,
        payment_date_display: installment.payment_date,
    }));

    const { formattedData, columns } = useTableConfig({
        data: formattedInstallments,
        page: 1,
        limit: 10,
        canShowAction: false,
        config: {
            entityName: "Loan Installments",
            idKey: "loan_installment_id",
            displayFields: generateDisplayFields(displayFields),
        },
        IsEdit: false,
        IsDelete: false,
        isView: false,
        isPrint: false,
    });

    useEffect(() => {
        if (!id) return;

        if (hasFetched.current) return;
        hasFetched.current = true;

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await GetInstallmentsByLoanId(id);
                if (response?.success || response?.data?.success) {
                    setInstallments(response.data?.data || []);
                } else {
                    setInstallments([]);
                }
            } catch (error) {
                console.error("Fetch Error:", error);
                setInstallments([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    return (
        <PageBody card headerchildren={<HeadingOne>Loan Installments</HeadingOne>}>
            {loading ? (
                <Spinner isSpinner />
            ) : (
                <div className="col-12">
                    <DataTable
                        columns={columns}
                        data={formattedData}
                        options={{
                            loading: false,
                            sortableColumns: displayFields.map((field) => field.name),
                            print: true,
                            csv: true,
                            pdf: true,
                            copy: true,
                        }}
                        Entries={{ Entries: false }}
                        Search={{ search: false }}
                        pagination={{ isActive: false }}
                    />
                </div>
            )}
        </PageBody>
    );
};

export default ViewInstallment;
